"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.syncServiceDetails = exports.companyObjectType = exports.endUsersObjectType = exports.syncServiceNames = void 0;
exports.syncServiceNames = [
    "hubspot",
    "stripe",
    "woocommerce",
    "shopify",
    "thrivecart",
];
exports.endUsersObjectType = "person";
exports.companyObjectType = "company";
exports.syncServiceDetails = {
    hubspot: {
        name: "hubspot",
        humanName: "HubSpot",
        endUsersObjectType: "contacts",
        companyObjectType: "companies",
        enchargeIdField: "HubSpot.hs_object_id",
        lastSyncAtField: "HubSpot.lastSyncAt",
    },
    stripe: {
        name: "stripe",
        humanName: "Stripe",
        endUsersObjectType: "customers",
        enchargeIdField: "Stripe.Customer-ID",
        lastSyncAtField: "Stripe.Last-Sync-At",
    },
    woocommerce: {
        name: "woocommerce",
        humanName: "WooCommerce",
        endUsersObjectType: "customers",
        enchargeIdField: "WooCommerce.customer_id",
        lastSyncAtField: "WooCommerce.lastSyncAt",
    },
    shopify: {
        name: "shopify",
        humanName: "Shopify",
        endUsersObjectType: "customers",
        enchargeIdField: "Shopify.customer_id",
        lastSyncAtField: "Shopify.lastSyncAt",
    },
    thrivecart: {
        name: "thrivecart",
        humanName: "ThriveCart",
        endUsersObjectType: "customers",
        enchargeIdField: "ThriveCart.customer_id",
        lastSyncAtField: "ThriveCart.lastSyncAt",
    },
};
//# sourceMappingURL=sync_engine_helper.js.map